
























import Element from '../../../mixins/element';
import CardType from '../../../components/CardType.vue';
import { hardCodeBrand } from '../../../../services';
import { Component, Watch } from 'vue-property-decorator';

@Component({
    components: {
        CardType,
    },
})
export default class CreditCard extends Element {
    get id() {
        return this.integrationData.setup.fields
            ? this.integrationData.setup.fields.cardNumber.selector.replace('#', '')
            : 'cardNumberPS';
    }

    public toMount() {
        this.loading = true;
        this.$nextTick(() => {
            this.loading = false;
        });
    }

    public performInput(event) {
        const localBrandMapping = {
            'American Express': 'amex',
        };
        const brand = hardCodeBrand(localBrandMapping[event.data.cardBrand] || event.data.cardBrand);
        const empty = event.data.isEmpty;
        this.input = {
            brand,
            isEmpty: empty,
        };
    }

    public onIntegrationData(val) {
        if (!Object.keys(val).length) {
            return;
        }

        this.loading = false;
        val.fields.cardNumber.on('FieldValueChange', (data, event) => {
            this.performInput(event);
        });

        val.fields.cardNumber.on('Focus', (data, event) => {
            this.onFocus();
        });

        val.fields.cardNumber.on('Blur', (data, event) => {
            this.onBlur();
        });

        val.fields.cardNumber.on('Valid', (data, event) => {
            this.performInput(event);
        });

        val.fields.cardNumber.on('Invalid', (data, event) => {
            this.performInput(event);
        });
    }

    public toValidate(): boolean {
        return this.integrationData.paysafe.fields.cardNumber.isValid();
    }

    public toClear() {}

    public toDestroy() {}

    public toFocus(): void {}

    public toBlur(): void {}
}
